import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import setColorMode from './setColorMode';
export var ColorModeContext = createContext();

var ColorModeProvider = function ColorModeProvider(_ref) {
  var children = _ref.children;

  var _setColorMode = setColorMode(),
      _setColorMode2 = _slicedToArray(_setColorMode, 2),
      colorMode = _setColorMode2[0],
      toggleColorMode = _setColorMode2[1];

  return React.createElement(ColorModeContext.Provider, {
    value: {
      colorMode: colorMode,
      toggleColorMode: toggleColorMode
    }
  }, children);
};

var getColorMode = function getColorMode() {
  var context = useContext(ColorModeContext);

  if (context === undefined) {
    throw new Error('setColorMode must be used within a ColorModeProvider');
  }

  var colorMode = context.colorMode;
  return colorMode;
};

export default ColorModeProvider;
export { getColorMode };